// Тексты по постановке «Вызов создания записи через РП»: R1 и сценарий 1.1.2
const noRightsText =
  "Недостаточно прав для создания записи через рабочий поток";
const noInitialText =
  "Администратору необходимо указать Initial у пользовательского шага";
const createText = "Создание записи через рабочий поток";

const withWorkflowTitle = (text: string, workflowTitle: string) =>
  workflowTitle ? `${text} «${workflowTitle}»` : text;

type ParamsWorkflowCreateState = {
  /** Нет прав на создание записи через РП. Определяет бэкенд */
  noRights: boolean;
  /** Ни у одного пользовательского шага не указан Initial */
  noInitial: boolean;
  workflowTitle: string;
};

export const getWorkflowCreateState = ({
  noRights,
  noInitial,
  workflowTitle,
}: ParamsWorkflowCreateState): { disabled: boolean; tooltip: string } => {
  if (noRights) {
    return {
      disabled: true,
      tooltip: withWorkflowTitle(noRightsText, workflowTitle),
    };
  }
  if (noInitial) return { disabled: true, tooltip: noInitialText };
  return {
    disabled: false,
    tooltip: withWorkflowTitle(createText, workflowTitle),
  };
};
